import { createContext } from "react";

import { Theme } from "@/modules/theme/utils/createTheme";

export const ThemeContext = createContext<{ theme: Theme }>({
  get theme(): never {
    throw new Error("Missing ThemeProvider");
  },
});
